module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "CardCircularGraphics mt-4",
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pb-4"
  }, [_vm._v(_vm._s(_vm.$t("CardCircularGraphics.geolocatedView")))]), _vm._v(" "), _c('v-container', {
    staticClass: "Content d-flex pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "Options overflow-hidden pr-1 mr-3"
  }, [_c('h3', {
    staticClass: "headline mt-2 mb-3"
  }, [_vm._v(_vm._s(_vm.$t("CardCircularGraphics.variables")))]), _vm._v(" "), _vm._l((_vm.getOptionsKeys), function(key) {
    return _c('div', {
      key: key,
      class: {
        IonOption: key === 'io_report'
      }
    }, [(key === 'io_report') ? _c('h3', {
      staticClass: "headline mt-4 mb-3"
    }, [_vm._v(_vm._s(_vm.$t("CardCircularGraphics.irrigationOrders")))]) : _vm._e(), _vm._v(" "), _c('div', {
      class: {
        Opt: true,
        Active: _vm.options[key].checked
      },
      on: {
        "click": function($event) {
          return _vm.toggleOpt(key)
        }
      }
    }, [(_vm.options[key].checked) ? _c('v-icon', {
      staticClass: "mt-1 fill-height",
      attrs: {
        "small": "",
        "color": "#0098E1"
      }
    }, [_vm._v("radio_button_checked")]) : _c('v-icon', {
      staticClass: "mt-1",
      attrs: {
        "small": ""
      }
    }, [_vm._v("radio_button_unchecked")]), _vm._v(" "), _c('p', {
      staticClass: "subheading d-inline-block ml-1 mb-2"
    }, [_vm._v(_vm._s(_vm.options[key].label))])], 1), _vm._v(" "), _vm._l((_vm.options[key].subOptions), function(subOpt, i) {
      return _c('div', {
        key: subOpt.label,
        class: {
          Opt: true,
          Active: (_vm.options[key].checked && subOpt.checked),
          'ml-4': true
        },
        on: {
          "click": function($event) {
            return _vm.toggleSubOpt(key, i)
          }
        }
      }, [((_vm.options[key].checked && subOpt.checked)) ? _c('v-icon', {
        staticClass: "mt-1",
        attrs: {
          "small": "",
          "color": subOpt.color ? subOpt.color : '#0098E1'
        }
      }, [_vm._v("radio_button_checked")]) : _c('v-icon', {
        staticClass: "mt-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v("radio_button_unchecked")]), _vm._v(" "), _c('p', {
        staticClass: "subheading d-inline-block ml-1 mb-2",
        style: ({
          color: (_vm.options[key].checked && subOpt.checked) ? subOpt.color : ''
        })
      }, [_vm._v(_vm._s(subOpt.label))])], 1)
    })], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "Graphic fill-height d-flex align-center justify-center"
  }, [(_vm.checkedOpt.img) ? [(_vm.circGraphsData.position) ? _c('div', {
    staticClass: "GraphicImage"
  }, [_c('div', [_c('CardSatelliteImage', {
    attrs: {
      "hasHeatmap": _vm.checkedKey === 'altimetry',
      "position": _vm.getCoordinate(_vm.circGraphsData.position),
      "zoom": _vm.circGraphsData.zoom,
      "equipLength": _vm.circGraphsData.equipLength,
      "heatmapData": _vm.heatmapData,
      "elevationReference": _vm.elevationReference,
      "addTransparentLayer": _vm.checkedKey === 'altimetry' && !!_vm.checkedOpt.subOptions.filter(function (opt) { return opt.checked; }).length,
      "mapInstanceId": _vm.locationName
    },
    on: {
      "update:heatmapData": function($event) {
        _vm.heatmapData = $event
      },
      "update:heatmap-data": function($event) {
        _vm.heatmapData = $event
      },
      "update:elevationReference": function($event) {
        _vm.elevationReference = $event
      },
      "update:elevation-reference": function($event) {
        _vm.elevationReference = $event
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "AngleLabel Top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("CardCircularGraphics.north")))]), _c('br'), _c('span', [_vm._v("0°")])]), _vm._v(" "), _c('p', {
    staticClass: "AngleLabel Right"
  }, [_vm._v("90°")]), _vm._v(" "), _c('p', {
    staticClass: "AngleLabel Bottom"
  }, [_vm._v("180°")]), _vm._v(" "), _c('p', {
    staticClass: "AngleLabel Left"
  }, [_vm._v("270°")])], 1), _vm._v(" "), (_vm.checkedKey === 'altimetry') ? _c('CardPressureChart', {
    attrs: {
      "subOptions": _vm.checkedOpt.subOptions,
      "circularData": _vm.circGraphsData
    },
    on: {
      "onClickMarker": _vm.setExtraInfoData
    }
  }) : _vm._l((_vm.checkedOpt.subOptionsLayers), function(subOption) {
    return (subOption.checked && subOption.chart === 'pie') ? _c('CardPieChart', {
      key: subOption.key,
      attrs: {
        "optKey": subOption.key,
        "circularData": _vm.circGraphsData,
        "selectedFault": _vm.selectedFault,
        "selectedIOReport": _vm.selectedIOReport
      },
      on: {
        "onClickSection": _vm.setExtraInfoData
      }
    }) : _vm._e()
  })], 2) : _c('span', {
    staticClass: "display-1 text-center grey--text"
  }, [_vm._v(_vm._s(_vm.$t("CardCircularGraphics.imageNotAvailable")))])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "ExtraInfo d-flex pl-3"
  }, [(_vm.extraInfoData) ? _c('div', {
    staticClass: "d-flex justify-space-between"
  }, [_c('div', _vm._l((_vm.extraInfoData), function(data) {
    return _c('p', {
      key: data[0],
      staticClass: "body-2",
      domProps: {
        "innerHTML": _vm._s(data[0])
      }
    })
  }), 0), _vm._v(" "), _c('div', _vm._l((_vm.extraInfoData), function(data) {
    return _c('p', {
      key: data[1],
      staticClass: "body-2",
      domProps: {
        "innerHTML": _vm._s(data[1])
      }
    })
  }), 0)]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.checkedKey === 'real_image' && _vm.options[_vm.checkedKey].subOptionsLayers.filter(function (layer) { return layer.key === 'faults'; }).length && _vm.parsedSelectedFault) ? _c('div', {
    staticClass: "FaultsDescription d-flex mb-5 justify-space-between"
  }, [_c('div', _vm._l((_vm.parsedSelectedFault), function(data) {
    return _c('p', {
      key: data[0],
      staticClass: "body-2",
      domProps: {
        "innerHTML": _vm._s(data[0])
      }
    })
  }), 0), _vm._v(" "), _c('div', _vm._l((_vm.parsedSelectedFault), function(data) {
    return _c('p', {
      key: data[1],
      staticClass: "body-2",
      domProps: {
        "innerHTML": _vm._s(data[1])
      }
    })
  }), 0)]) : (_vm.checkedKey === 'io_report' && _vm.ioReportExtraData) ? _c('div', {
    staticClass: "DegreeCompliance text-center mb-5"
  }, [_c('p', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.$t("CardCircularGraphics.degreeOfCompliance")))]), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "transparent"
    },
    scopedSlots: _vm._u([{
      key: "badge",
      fn: function() {
        return undefined
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-progress-circular', {
    staticClass: "ProgressCircular",
    attrs: {
      "rotate": -90,
      "size": 80,
      "width": 6,
      "value": _vm.ioReportExtraData.doc,
      "color": "#0098E1"
    }
  }, [_c('span', {
    staticClass: "headline black--text"
  }, [_vm._v(_vm._s(_vm.ioReportExtraData.doc) + "%")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex text-xs-left mt-3"
  }, [_c('div', {
    staticClass: "subheading pr-2"
  }, _vm._l((_vm.ioReportExtraData.itemData), function(data) {
    return _c('p', {
      key: data[0],
      domProps: {
        "innerHTML": _vm._s(data[0])
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, _vm._l((_vm.ioReportExtraData.itemData), function(data) {
    return _c('p', {
      key: data[0] + data[1],
      domProps: {
        "innerHTML": _vm._s(data[1])
      }
    })
  }), 0)])], 1) : (_vm.checkedKey === 'altimetry' && _vm.elevationReference) ? _c('div', {
    staticClass: "AltimetryReference d-flex mb-3"
  }, [_c('div', {
    staticClass: "ColorReference ml-3"
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "ElevationValues",
    attrs: {
      "column": ""
    }
  }, [_c('p', {
    staticClass: "ma-1 ml-3 subheading"
  }, [_vm._v(_vm._s(_vm.elevationReference.max.toFixed(1)) + " m")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('p', {
    staticClass: "ma-1 ml-3 subheading"
  }, [_vm._v(_vm._s(_vm.elevationReference.min.toFixed(1)) + " m")])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.checkedKey === 'real_image' && _vm.options[_vm.checkedKey].subOptionsLayers.filter(function (layer) { return layer.key === 'faults'; }).length) ? [_c('FaultsDetailsList', {
    attrs: {
      "faults": _vm.circGraphsData.faults,
      "title": _vm.title,
      "locationName": _vm.locationName,
      "selectedFault": _vm.selectedFault
    },
    on: {
      "update:selectedFault": function($event) {
        _vm.selectedFault = $event
      },
      "update:selected-fault": function($event) {
        _vm.selectedFault = $event
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.checkedKey === 'io_report') ? [_c('IOReportDetailsList', {
    attrs: {
      "ioReportItems": _vm.circGraphsData.io_report_items,
      "title": _vm.title,
      "locationName": _vm.locationName,
      "selectedIOReport": _vm.selectedIOReport
    },
    on: {
      "update:selectedIOReport": function($event) {
        _vm.selectedIOReport = $event
      },
      "update:selected-i-o-report": function($event) {
        _vm.selectedIOReport = $event
      }
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ce47b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/CardCircularGraphics.vue
// module id = 1719
// module chunks = 0